<script>
    import {fade, fly} from 'svelte/transition';
    import {createEventDispatcher} from 'svelte/internal';
    import CloseButton from "../controls/CloseButton.svelte";

    export let title = '';
    export let modalMd = false;
    export let modalLg = false;
    export let modalXl = false;
    export let showCloseButton = true;
    export let closeOnEscape = true;
    export let visible = true;
    export let bodyClass = '';
    export let onBeforeClose = null;

    let nowState = false;

    const dispatch = createEventDispatcher();


    const close = () => {
        let doClose = true;
        if (onBeforeClose != null) {
            doClose = onBeforeClose();
            console.log("Result", doClose);
        }

        if (!doClose) {
            return;
        }

        visible = false;
        setTimeout(() => {
            dispatch('close');
        }, 200);
    }

    $: if (nowState != visible && closeOnEscape) {
        if (visible) {
            nowState = visible;
        }
    }
</script>
{#if visible}
    <div class="modal-overlay" id="moooodal" transition:fade="{{ duration: 100 }}">
        <div class="wrapper" class:full-screen={modalXl}>
            <div class="panel modal-panel" class:modal-md={ modalMd } class:modal-lg={modalLg} class:modal-xl={modalXl} in:fly="{{ y: -20, duration: 200 }}">
                <div class="panel-heading panel-pad">
                    <div class="title">
                        { title }
                    </div>
                    {#if showCloseButton}
                        <CloseButton on:click="{ close }"/>
                    {/if}
                </div>
                <div class="panel-body panel-pad { bodyClass }">
                    <slot name="body"/>
                </div>
                <slot name="footer"/>
            </div>
        </div>
    </div>
{/if}

<style>
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9000;
        overflow-y: auto;
    }

    .modal-overlay .wrapper {
        position: absolute;
        width: 100%;
        padding: 10px 0;
    }

    .modal-panel {
        width: max-content;
        max-width: 300px;
        background: #fff;
        border-radius: 2px;
        padding-top: 5px;
        transition: .3s all ease;
        margin: 0 auto;
        overflow: hidden;
    }

    .modal-overlay .wrapper.full-screen {
        padding: 10px;
    }

    .modal-panel.modal-md {
        width: 800px;
    }

    .modal-panel.modal-lg {
        width: calc(100% - 10px);
        max-width: 1024px;
    }

    .modal-panel.modal-xl {
        width: 100%;
        min-height: calc(100vh - 20px);
    }

    .modal-panel .panel-heading {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .modal-panel .panel-heading .title {
        font-size: 18px;
    }

    @media (max-width: 576px) {
        .modal-panel {
            width: calc(100vw - 20px);
        }
    }

    @media (min-width: 768px) and (max-width: 991px) {
        .modal-md {
            width: calc(100% - 20px);
        }
    }

    @media (min-width: 992px) {
        .modal-panel {
            min-width: 450px;
        }
    }

    @media (min-width: 1200px) {
        .modal-overlay .wrapper {
            padding: 30px 0;
        }
    }
</style>